<template>
  <div class="audit" v-if="isSuccess">
    <i class="el-icon-warning text-5xl" style="color: #e8a31b"></i>
    <div class="audit__title">短信群发审核中</div>
    <div class="audit__introduce">由于短信运营商的限制，短信群发需要进行内容审核，审核通过后将立即为您发送短信。</div>
    <div class="audit__qrcode">
      <div class="customer-service">
        <div>如有疑问请扫码联系客服</div>
        <!-- 动态样式 -->
        <div class="mt-2" :style="(customerUserInfo.weixinBinding && !customerUserInfo.weixinFans) ? 'margin-top: 29px' : ''">
          <img class="w-32" src="/assets/img/code/Customer.Service.png" />
        </div>
      </div>
      <div class="focus-on">
        <!-- <div>关注调研工厂+服务号</div>
        <div>实时获取审核结果</div>
        <div class="img">
          <img :src="codeSrc" />
        </div> -->

        <!-- 未绑定微信 -->
        <template v-if="!customerUserInfo.weixinBinding">
          <div>绑定微信，可实时获取审核结果</div>
          <el-button class="mt-2" type="primary" @click="personalMsgShow = true">绑定微信</el-button>
        </template>
        <!-- 已绑定微信且未关注公众号 -->
        <template v-else-if="customerUserInfo.weixinBinding && !customerUserInfo.weixinFans">
          <div>关注"调研工厂+"公众号</div>
          <div>可实时获取审核结果</div>
          <img class="w-32 mt-2" :src="codeSrc" alt="公众号二维码" />
        </template>
        <!-- 已绑定微信且已关注公众号 -->
        <template v-else>
          <div>审核结果将通过"调研工厂+"公众号推送</div>
          <img class="w-32 mt-2" src="/assets/img/code/Mrs.Chai.png" />
        </template>
      </div>
    </div>
    <!-- 个人设置组件 -->
    <PersonalMsg v-if="personalMsgShow" :personalMsgShow="personalMsgShow" @onCloseDialog="personalMsgShow = false" :openQrCode="true" />
  </div>
  <section class="w-full h-full flex flex-col items-center justify-center" v-else>
    <i class="el-icon-error text-9xl text-danger"></i>
    <p class="mt-8 text-theme-black-850 text-medium">由于网络异常，群发短信 发送失败，请稍后重试</p>
    <div class="mt-6 flex items-center justify-center">
      <el-button type="primary" size="small" class="normal-button" @click="resetSend">重新发送</el-button>
      <el-button type="primary" size="small" class="normal-button" @click="failFinish">完成</el-button>
    </div>
  </section>
</template>

<script>
import { resend } from '@/api/pay/sms'
import { mapGetters } from 'vuex'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'StepPayResult',
  inject: {
    switchTab: {
      default: null
    },
    resetGSM: {
      default: null
    },
    source: {
      default: () => ({})
    }
  },
  data() {
    return {
      baseUrl: '',
      personalMsgShow: false,
      codeSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE
    }
  },
  created() {
    this.baseUrl = getSurveyDomain()
  },
  computed: {
    ...mapGetters(['customerUserInfo']), // weixinBinding: 是否绑定微信；
    isSuccess() {
      const { sendResult } = this.source?.smsRecord || {}
      return !!sendResult
    }
  },
  methods: {
    finish() {
      if (typeof this.switchTab === 'function') {
        this.switchTab('batchRecord', br => {
          br.searchList()
        })
      }
      if (typeof this.resetGSM === 'function') {
        this.resetGSM()
      }
    },
    resetSend() {
      const errMsg = '群发短信失败'
      const { smsRecordId } = this.source?.smsRecord || {}
      resend(smsRecordId)
        .then(res => {
          const { code, msg } = res?.data || {}
          if (code === 0) {
            this.$message.success('群发短信成功')
            this.finish()
          } else {
            this.$message.error(msg || errMsg)
          }
        })
        .catch(() => {
          this.$message.error(errMsg)
        })
    },
    failFinish() {
      if (typeof this.resetGSM === 'function') {
        this.resetGSM()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.audit {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px auto 0;

  &__title {
    margin-top: 8px;
    height: 22px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }

  &__introduce {
    margin-top: 12px;
    height: 22px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.65);
    line-height: 22px;
  }

  &__qrcode {
    margin-top: 40px;
    display: flex;

    div {
      height: 22px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: rgba($color: #000000, $alpha: 0.65);
      line-height: 22px;
      text-align: center;
    }

    .img {
      display: inline-block;
      width: 128px;
      height: 128px;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .focus-on {
      margin-left: 40px;

      & div:nth-child(2) {
        margin-top: 4px;
        height: 17px;
        font-size: 12px;
        color: rgba($color: #000000, $alpha: 0.45);
        line-height: 17px;
      }

    }
  }
}
</style>
